import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../auth/api";
import { alertSuccess, alertError } from "../../components/Alert";

// Fetch Reward Type
export const fetchRewardType = createAsyncThunk(
  "rewardType/fetchRewardType",
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get("/transaction/panel/RewardType");
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

// Add Reward Type
export const addRewardType = createAsyncThunk(
  "rewardType/addRewardType",
  async (newRewardData, { rejectWithValue }) => {
    try {
      const response = await api.post("/transaction/panel/RewardType", newRewardData);
      alertSuccess(response.data.success);
      return response.data;
    } catch (error) {
      alertError(error.response?.data.errors);
      return rejectWithValue(error.response?.data.errors || error.message);
    }
  }
);

// Update Reward Type
export const updateRewardType = createAsyncThunk(
  "rewardType/updateRewardType",
  async (rewardData, { rejectWithValue }) => {
    try {
      const response = await api.patch("/transaction/panel/RewardType", rewardData);
      alertSuccess(response.data.success);
      return response.data;
    } catch (error) {
      alertError(error.response?.data.errors);
      return rejectWithValue(error.response?.data.errors || error.message);
    }
  }
);

// Reward Type Slice
const rewardTypeSlice = createSlice({
  name: "rewardType",
  initialState: {
    rewardTypeList: [],
    status: "idle", // idle | loading | succeeded | failed
    error: null,
  },
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Fetch Reward Type
      .addCase(fetchRewardType.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(fetchRewardType.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.rewardTypeList = action.payload;
      })
      .addCase(fetchRewardType.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })
      // Add Reward Type
      .addCase(addRewardType.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(addRewardType.fulfilled, (state) => {
        state.status = "succeeded";
      })
      .addCase(addRewardType.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })
      // Update Reward Type
      .addCase(updateRewardType.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(updateRewardType.fulfilled, (state) => {
        state.status = "succeeded";
      })
      .addCase(updateRewardType.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      });
  },
});

export const { clearError } = rewardTypeSlice.actions;

export default rewardTypeSlice.reducer;
